import AreaFds from './AreaFds'

export default AreaFds



// WEBPACK FOOTER //
// ./src/containers/AreaFds/index.js